/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getUploadStatus.defs.js";
export { main as default } from "./getUploadStatus.defs.js";
